import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { filterActivityViewDataRequests } from "../activityView/applicationInsights/filterActivityViewDataRequests";
import { getJsonScriptContent } from "../utils/dom/getJsonScriptContent";
import { addContextAndRoleTags } from "./telemetryProcessors/addContextAndRoleTags";
import { filterSymfonyWdt } from "./telemetryProcessors/filterSymfonyWdt";

const element = document.getElementById("application-insights-options");
let appInsights = null;

if (element) {
    const {
        config,
        context,
        tags,
        authenticatedUserContext,
        enableCorsCorrelation = false,
        pageViewTitle = null,
    } = getJsonScriptContent(element);

    // Build connection string from config
    const connectionString = `InstrumentationKey=${config.instrumentationKey};IngestionEndpoint=${config.ingestionEndpoint}`;

    appInsights = new ApplicationInsights({
        config: {
            connectionString,
            enableCorsCorrelation: enableCorsCorrelation,
            excludeRequestFromAutoTrackingPatterns: [
                /rte\.eucerahive\.io/i,
                /agent\.eucerahive\.io/i,
                /cdn\.jsdelivr\.net/i,
                /\.hubspot\.com/i,
                /\.hsforms\.com/i,
                /\.mixpanel\.com/i,
                /([a-zA-Z0-9_-]+\.)?productfruits\.com/i,
            ],
        },
    });

    appInsights.loadAppInsights();

    const { accountId, authenticatedUserId } = authenticatedUserContext || {};
    if (accountId && authenticatedUserId) {
        appInsights.setAuthenticatedUserContext(authenticatedUserId, accountId);
    }

    appInsights.addTelemetryInitializer(addContextAndRoleTags(context, tags));
    appInsights.addTelemetryInitializer(filterActivityViewDataRequests);

    if (context.applicationVersion === "dev") {
        appInsights.addTelemetryInitializer(filterSymfonyWdt(context));
    }

    if (pageViewTitle) {
        appInsights.trackPageView({ name: pageViewTitle });
    }
}

export default appInsights;
